import { Link } from "react-router-dom";
import { Car, Wrench, Bike, Cpu, Trophy, Building2 } from "lucide-react";

const INDUSTRIES = [
  { icon: Car, title: "Automotive", text: "Emblematy, naklejki na felgi, oznaczenia dealerskie i tuningowe na folii chrom lub szczotkowanej stali." },
  { icon: Wrench, title: "Przemysł i maszyny", text: "Tabliczki znamionowe, oznaczenia paneli i przycisków odporne na mycie oraz oleje." },
  { icon: Bike, title: "Sport i rowery", text: "Naklejki na ramy, kaski i sprzęt – wypukłe logo, które nie odkleja się przy myciu." },
  { icon: Cpu, title: "Elektronika i AGD", text: "Wypukłe logotypy na obudowach, panelach i frontach urządzeń." },
  { icon: Trophy, title: "Reklama i gadżety", text: "Naklejki 3D z logo na materiały promocyjne, opakowania i gadżety B2B." },
  { icon: Building2, title: "Nieruchomości i usługi", text: "Oznakowanie lokali, tabliczki informacyjne, naklejki na drzwi i witryny." },
];

/** Industry entry points feeding the /zastosowania-branzowe landing page. */
const IndustriesGrid = () => (
  <section id="branze" className="py-12 md:py-20">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mb-8 md:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3">
          Naklejki 3D dla branż – gdzie sprawdzają się najlepiej
        </h2>
        <p className="text-muted-foreground leading-relaxed">
          Produkujemy naklejki wypukłe dla klientów biznesowych z całej Polski i Unii Europejskiej.
          Poniżej najczęstsze zastosowania – pełny opis znajdziesz na stronie zastosowań branżowych.
        </p>
      </div>
      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {INDUSTRIES.map((b) => (
          <li key={b.title} className="rounded-2xl border border-border bg-card p-5 hover:border-accent/60 transition-colors">
            <b.icon className="w-8 h-8 text-accent mb-3" aria-hidden="true" />
            <h3 className="font-bold text-foreground mb-2">{b.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{b.text}</p>
          </li>
        ))}
      </ul>
      <div className="mt-8">
        <Link
          to="/zastosowania-branzowe"
          className="inline-flex border-2 border-accent text-accent font-semibold px-6 py-3 rounded-lg hover:bg-accent hover:text-accent-foreground transition-colors"
        >
          Zobacz zastosowania branżowe
        </Link>
      </div>
    </div>
  </section>
);

export default IndustriesGrid;
